import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Explorer from './views/Explorer.vue'
import BDTNSDebugger from './views/BDTNSDebugger.vue'
import Zettelkasten from './views/Zettelkasten.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/explorer',
      name: 'explorer',
      component: Explorer
    },
    {
      path: '/bdtnsdebugger',
      name: 'bdtnsdebugger',
      component: BDTNSDebugger
    },
    {
      path: '/zettelkasten',
      name: 'zettelkasten',
      component: Zettelkasten
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router.js